import { Component, ChangeDetectionStrategy } from "@angular/core";

@Component({
  selector: "app-user-picker-no-search-results",
  templateUrl: "./user-picker-no-search-results.component.html",
  styleUrls: ["./user-picker-no-search-results.component.scss"],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class UserPickerNoSearchResultsComponent {}
